import { render, staticRenderFns } from "./ClipCard.vue?vue&type=template&id=4d057f4a&scoped=true&"
import script from "./ClipCard.vue?vue&type=script&lang=js&"
export * from "./ClipCard.vue?vue&type=script&lang=js&"
import style0 from "./ClipCard.vue?vue&type=style&index=0&id=4d057f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d057f4a",
  null
  
)

export default component.exports